import styled from '@emotion/styled';
import { colors, spacing, typography } from '../../../themes';
import { IconButton } from '../../Input/IconButton';
import { Container } from '../../Surfaces/Container';

export const PopoverContainer = styled(Container)<{ darkMode?: boolean }>`
  position: relative;
  max-width: 370px;
  padding: ${spacing.xsmall};
  z-index: 10;
  background-color: ${({ darkMode }) => (darkMode ? '#62636A' : colors.base.white)};
  color: ${({ darkMode }) => (darkMode ? colors.base.white : colors.base.black)};
  ${typography.body.large};

  button {
    opacity: 0;
    transform: scale(0.9);
    pointer-events: none;
    transition:
      opacity 200ms ease-out,
      transform 200ms ease-out;
  }

  &:hover button {
    opacity: 1;
    transform: scale(1);
    pointer-events: auto;
  }
`;

export const PopoverContent = styled.div`
  padding-right: ${spacing.xmsmall};
`;

export const PopoverCloseButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
`;

export const PopoverCloseButton = styled(IconButton)<{ darkMode?: boolean }>`
  min-width: unset;
  padding: ${spacing.xxsmall};
  background-color: ${({ darkMode }) =>
    darkMode ? colors.monochrome.grey60 : colors.monochrome.grey10};

  width: 24px;
  height: 24px;
  padding: 4px;

  &:hover:not(:disabled) {
    background-color: ${({ darkMode }) =>
      darkMode ? colors.monochrome.grey60 : colors.monochrome.grey30};

    height: 32px;
    width: 32px;
  }

  &:active:not(:disabled) {
    background-color: ${({ darkMode }) =>
      darkMode ? colors.monochrome.grey60 : colors.monochrome.grey30};
  }

  transition:
    width 200ms ease-out,
    height 200ms ease-out;
`;
